import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatment } from '~/domains/common/hooks/useTreatment';

function useQuickPicksEnterCheck() {
  const { isReady, treatment } = useTreatment(FEATURE.ENABLE_PROPS);

  const isEnabled = treatment.treatment === 'on';

  return {
    isLoading: !isReady,
    isEnabled,
  };
}

export default useQuickPicksEnterCheck;
